<template>
  <div class="students-list-heading truncate" :class="`text-xs-${alignment}`">
    <v-tooltip bottom>
      <span slot="activator">{{$t(text)}}</span>
      <span>{{$t(text)}}</span>
    </v-tooltip>
  </div>
</template>

<script>
  export default {
    name: 's-header-tooltip',
    props: {
      text: {},
      alignment: {
        default: 'left'
      }
    },
    mixins: [],
    data () {
      return {}
    },
    methods: {},
    computed: {},
    watch: {}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/intervention/studentProfileIntervention/SHeaderTooltip.vue